<mat-tab-group animationDuration="0ms" class="tabs-reportes" [disableRipple]="true">
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="raya-menu-right"></div>
        <div class="btn-menu-reportes">
          <img src="../../../../../assets/ico__intro_off.svg">
        </div>
        <span class="span-titulo">Introducción</span>
      </ng-template>
      <br><br>
      
      <h1 class="informacion-titulo">Reportes y Datos de Procesos</h1>
      <div class="informacion">
          <p>
            Esta sección ha sido diseñada con el fin de entregar información relevante dentro de las distintas etapas de la Aplicación del 
            Modelo de Gestión de Calidad para la Educación Parvularia, para la Junta Nacional de Jardines Infantiles. 
            Permite monitorear, de forma global o particular, el trabajo que llevan a cabo los Jardines Infantiles 
            en el marco del Modelo de Gestión de Calidad.
          </p>
      </div>       

    </mat-tab>
    
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="raya-menu-center"></div>
        <div class="btn-menu-reportes">
          <img src="../../../../../assets/ico__ autoevaluacion_off.svg">
        </div>
        <span class="span-titulo">Consolidado</span>
      </ng-template>
      <br><br>

      <app-consolidado></app-consolidado>
  
    </mat-tab>
  
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="raya-menu-center"></div>
        <div class="btn-menu-reportes">
          <img src="../../../../../assets/ico__capacitacion_off.svg">
        </div>
        <span class="span-titulo">Capacitación</span>
      </ng-template>
      <br><br>
      
      <app-capacitacion></app-capacitacion>
      
  
      <table class="table_card">
        <tr>
          <td>
            <mat-card class="reportes-card">
              <mat-card-header>
                <mat-card-title class="titulo_celeste">Capacitación
                  <p>Presencial</p>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <button mat-raised-button class="btn_morado">Ir</button>
              </mat-card-content>
            </mat-card>
          </td>
          <td>
            <mat-card class="reportes-card">
              <mat-card-header>
                <mat-card-title class="titulo_morado">Capacitación
                  <p>A distancia</p>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <button mat-raised-button class="btn_morado">Ir</button>
              </mat-card-content>
            </mat-card>
          </td>
          <td></td>
          <td></td>
        </tr>
      </table>
  
    </mat-tab>
  
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="raya-menu-center"></div>
        <div class="btn-menu-reportes">
          <img src="../../../../../assets/ico__ autoevaluacion_off.svg">
        </div>
        <span class="span-titulo">Autoevaluación</span>
      </ng-template>
      <br><br>

      <app-auto-evaluacion></app-auto-evaluacion>
  
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="raya-menu-center"></div>
        <div class="btn-menu-reportes">
          <img src="../../../../../assets/ico__validacion_off.svg">
        </div>
        <span class="span-titulo">Validación Externa</span>
      </ng-template>
    <br><br>
    
    <app-validacion></app-validacion>
   
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="raya-menu-center"></div>
        <div class="btn-menu-reportes">
          <img src="../../../../../assets/ico__plan_off.svg">
        </div>
        <span class="span-titulo">Plan de Mejoramiento</span>
      </ng-template>
      <br><br>
     
      <app-plan-de-mejoramiento></app-plan-de-mejoramiento>
      
      </mat-tab>
  </mat-tab-group>